import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { GET_PROCESS_HISTORY_WATCHER } from "./constants"
import {
  getProcessHistorySuccess,
  getProcessHistoryFailed
} from "./actions"
import { LOCAL_COMPANY_ID } from "../../../utils/storage"

// GET PROCESS HISTORIES
export function* getProcessHistoriesSaga() {
  try {
    const { data, status } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `record/process-histories`,
    })

    if (status === 200) {
      yield put(getProcessHistorySuccess(data.data))
    }
  } catch (error) {
    yield put(getProcessHistoryFailed())
    returnMessage(error)
  }
}



// Individual exports for testing
export default function* processHistoriesSaga() {
  yield takeLatest(GET_PROCESS_HISTORY_WATCHER, getProcessHistoriesSaga)
}
